module.exports = __webpack_public_path__ + "static/hero-image-prizes-c0436b4c6e2c83cc4d667e5ebebdf238.png";